<template>
  <div v-if="book.description" class="synopsis-section glass-card pa-6 mb-6">
    <div class="d-flex align-center ga-2 mb-3">
      <v-icon color="#10b981" size="22">mdi-book-open-page-variant-outline</v-icon>
      <h3 class="text-subtitle-1 font-weight-bold mb-0">Book Summary & Synopsis</h3>
    </div>
    <p class="synopsis-text text-body-1 mb-0">{{ book.description }}</p>
  </div>
</template>

<script>
export default {
  name: 'BookSynopsis',
  props: {
    book: { type: Object, required: true },
  },
}
</script>

<style scoped>
.synopsis-text {
  line-height: 1.8;
  letter-spacing: 0.01em;
  opacity: 0.9;
  white-space: pre-line;
}
</style>

